/* Cadeaux offerts.
   Chaque ligne cadeau porte la propriete _gift_for = id du produit principal.

   Principe : on ne corrige jamais le panier APRES coup (ca provoque un clignotement,
   le theme ayant deja affiche l'ancien etat). On reecrit la requete AVANT qu'elle parte,
   pour que le HTML renvoye par Shopify soit deja le bon. */
(function () {
  'use strict';

  var GIFT_PROP = '_gift_for';
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;
  var CART_CHANGE = /\/cart\/change(\.js)?(\?|$)/;
  var CART_OTHER = /\/cart\/(update|clear)(\.js)?(\?|$)/;

  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var pending = null;
  var adding = 0;      // un ajout est en cours : le filet de securite doit se taire

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function json(url, payload) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function getCart() {
    return nativeFetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function giftParentOf(item) {
    var p = item && item.properties;
    var v = p && p[GIFT_PROP];
    return v ? String(v) : null;
  }

  function giftsOf(cart, productId) {
    return cart.items.filter(function (it) { return giftParentOf(it) === String(productId); });
  }

  /* ---- Ajout : les cadeaux partent AVANT le produit principal, parce que le theme
     demande le HTML du tiroir dans la meme requete que l'ajout. ---- */
  function addGifts(block) {
    var parent = block.getAttribute('data-parent-product');
    var variants = (block.getAttribute('data-gift-variants') || '').split(',').filter(Boolean);
    if (!parent || !variants.length) return Promise.resolve();

    return getCart().then(function (cart) {
      var already = {};
      giftsOf(cart, parent).forEach(function (it) { already[String(it.variant_id)] = true; });
      var items = variants.filter(function (v) { return !already[v]; }).map(function (v) {
        var props = {};
        props[GIFT_PROP] = String(parent);
        return { id: Number(v), quantity: 1, properties: props };
      });
      if (!items.length) return;
      return json(cartUrl('cart/add.js'), { items: items });
    }).catch(function () {});
  }

  /* ---- Modification d'une ligne : on reecrit la requete du theme. ---- */
  function handleChange(input, opts) {
    var body;
    try { body = JSON.parse(opts.body); } catch (e) { return nativeFetch(input, opts); }

    return getCart().then(function (cart) {
      var idx = -1;
      if (body.line) {
        idx = Number(body.line) - 1;
      } else if (body.id) {
        idx = cart.items.findIndex(function (it) {
          return it.key === body.id || String(it.variant_id) === String(body.id);
        });
      }
      var item = cart.items[idx];
      if (!item) return nativeFetch(input, opts);

      // Ligne cadeau : jamais plus d'un exemplaire.
      if (giftParentOf(item)) {
        if (Number(body.quantity) > 1) {
          body.quantity = 1;
          return nativeFetch(input, Object.assign({}, opts, { body: JSON.stringify(body) }));
        }
        return nativeFetch(input, opts);
      }

      // Produit principal retire : on enleve ses cadeaux dans la MEME requete,
      // pour que le tiroir se redessine deja sans eux.
      if (Number(body.quantity) !== 0) return nativeFetch(input, opts);

      var updates = {};
      updates[item.variant_id] = 0;
      giftsOf(cart, item.product_id).forEach(function (g) { updates[g.variant_id] = 0; });

      var payload = { updates: updates };
      if (body.sections) payload.sections = body.sections;
      if (body.sections_url) payload.sections_url = body.sections_url;
      return json(cartUrl('cart/update.js'), payload);
    }).catch(function () { return nativeFetch(input, opts); });
  }

  /* ---- Filet de securite : rattrape les cas non interceptes (retour arriere du
     navigateur, panier modifie dans un autre onglet, application tierce). ---- */
  function reconcile() {
    // Pendant un ajout, le produit principal n'est pas encore au panier alors que ses
    // cadeaux y sont deja : reconcilier maintenant les supprimerait a tort.
    if (busy || adding) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var present = {};
      cart.items.forEach(function (it) {
        if (!giftParentOf(it)) present[String(it.product_id)] = true;
      });
      var updates = {};
      var changed = false;
      cart.items.forEach(function (it) {
        var parent = giftParentOf(it);
        if (!parent) return;
        var target = present[parent] ? 1 : 0;
        if (it.quantity !== target) { updates[it.variant_id] = target; changed = true; }
      });
      if (!changed) return;
      return json(cartUrl('cart/update.js'), { updates: updates }).then(function () {
        if (/\/cart\b/.test(window.location.pathname)) window.location.reload();
      });
    }).catch(function () {}).then(function () { busy = false; });
  }

  function scheduleReconcile() {
    clearTimeout(pending);
    pending = setTimeout(reconcile, 400);
  }

  function install() {
    var block = document.querySelector('[data-ddf-gifts]');
    var parentVariants = block ? (block.getAttribute('data-parent-variants') || '').split(',').filter(Boolean) : [];
    var giftVariants = block ? (block.getAttribute('data-gift-variants') || '').split(',').filter(Boolean) : [];

    function isMainProductAdd(body) {
      if (!block || !body) return false;
      var id = null;
      if (typeof FormData !== 'undefined' && body instanceof FormData) id = body.get('id');
      else if (typeof body === 'string') { try { id = (JSON.parse(body) || {}).id; } catch (e) { id = null; } }
      if (!id) return false;
      id = String(id);
      if (giftVariants.indexOf(id) !== -1) return false;
      return parentVariants.indexOf(id) !== -1;
    }

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var opts = init || {};

      if (CART_ADD.test(url)) {
        if (isMainProductAdd(opts.body)) {
          adding++;
          clearTimeout(pending);
          return addGifts(block)
            .then(function () { return nativeFetch(input, init); })
            .then(function (res) { adding--; return res; },
                  function (e) { adding--; throw e; });
        }
        return nativeFetch(input, init);
      }
      if (CART_CHANGE.test(url) && typeof opts.body === 'string') {
        return handleChange(input, opts);
      }
      if (CART_OTHER.test(url)) {
        return nativeFetch(input, init).then(function (res) { scheduleReconcile(); return res; });
      }
      return nativeFetch(input, init);
    };
  }

  window.DDFGifts = { reconcile: reconcile };

  function init() { install(); reconcile(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
